import type { ReactNode } from 'react';
import { parseBulletMarkup } from '@nest-recruit/shared';

/**
 * A brief bullet with its bold and links (JB-5), built as elements from the shared parser and
 * never as HTML, so nothing typed into a bullet can run in someone else's browser.
 */
export function BulletText({ text }: { readonly text: string }): ReactNode {
  return (
    <>
      {parseBulletMarkup(text).map((segment, index) => {
        if (segment.kind === 'bold') return <strong key={index}>{segment.text}</strong>;
        if (segment.kind === 'link') {
          return (
            <a key={index} href={segment.href} target="_blank" rel="noopener noreferrer" onClick={(event) => event.stopPropagation()}>
              {segment.text}
            </a>
          );
        }
        return <span key={index}>{segment.text}</span>;
      })}
    </>
  );
}
